import {Typography} from '@mui/material';
import {FC} from 'react';

export const DocumentsLayout: FC = () => {
  return <Typography>Вкладка «Документы» находится в разработке</Typography>;
};
